import React from "react";
import { pushEventToDataLayer } from "../../helper/datalayer-utils";
import "./new-body-banner.m.css";

const NewBodyWidget = () => {
  const handleBannerClick = () => {
    console.log("ePaper Banner clicked");
    window.open(
      "https://epaper.deccanherald.com/?utm_source=dhsite&utm_medium=in-article&utm_campaign=awareness",
      "_blank"
    );
    if (window?.dataLayer) pushEventToDataLayer("ePaper_banner");
  };

  return (
    <div styleName="banner-wrapper" onClick={handleBannerClick}>
      <div styleName="banner-left">
        <div styleName="banner-title">START RIGHT. STAY RIGHT.</div>
        <div styleName="banner-subtext">Make DH Epaper your morning habit.</div>
      </div>

      <div styleName="banner-center">
        <div styleName="divider"/>
        <img src="/epaper-dh.svg" alt="epaper" styleName="banner-image"/>
      </div>

      <button styleName="banner-btn">
        <span styleName="mob-button-text">Epaper</span>
        <span styleName="dsk-button-text">READ TODAY’S EPAPER</span>
      </button>
    </div>
  );
};

export default NewBodyWidget;
